window.addEventListener("load", () => {
    const displayScreen = document.querySelector(".display-screen");
    if (!displayScreen) return;

    const buttons = document.querySelectorAll(".toggle-btn");
    const screens = document.querySelectorAll(".relative > div[id]:not(#navMenu):not(#mainApp):not(#screensaverApp)");
    const homeDesignNav = document.getElementById("homeDesignNav");
    const searchNavBtnContainer = document.getElementById("searchNavBtnContainer");
    const gridBtns = document.getElementById("gridBtns");
    const sliderBtns = document.getElementById("sliderBtns");
    const toggleLayout = document.getElementById("toggleLayout");
    const homeGrid = document.getElementById("homeGrid");
    const homeSlider = document.getElementById("homeSlider");
    const navMenu = document.getElementById("navMenu");
    const searchNavMenu = document.getElementById("searchNavMenu");
    const openFiltersBtn = document.getElementById("openFilters");
    const closeFiltersBtn = document.getElementById("closeFilters");
    const selectHome = document.getElementById("selectHome");
    const allHomeDesignsScreen = document.getElementById("allHomeDesigns");
    const compareHomeDesignsScreen = document.getElementById("compareHomeDesigns");
    const allHomeDesignsBtn = document.querySelector("[data-target='allHomeDesigns']");
    const systemResetBtn = document.getElementById("systemReset");
    const mainApp = document.getElementById("mainApp");
    const screensaverApp = document.getElementById("screensaverApp");

    let inactivityTimer;

    /***
     * Optimised Function to Toggle Active Screen
     */
    function setActiveScreen(targetId) {
        requestAnimationFrame(() => {
            screens.forEach(screen => screen.setAttribute("data-active", screen.id === targetId ? "true" : "false"));
            buttons.forEach(btn => btn.setAttribute("data-active", btn.dataset.target === targetId ? "true" : "false"));

            if (homeDesignNav) homeDesignNav.setAttribute("data-active", targetId === "allHomeDesigns" ? "true" : "false");
            if (searchNavBtnContainer) searchNavBtnContainer.setAttribute("data-active", targetId === "allHomeDesigns" ? "true" : "false");

            if (targetId === "allHomeDesigns" && gridBtns && sliderBtns && toggleLayout && homeGrid && homeSlider) {
                gridBtns.setAttribute("data-active", "true");
                sliderBtns.setAttribute("data-active", "false");
                toggleLayout.checked = true;
                homeGrid.setAttribute("data-active", "true");
                homeSlider.setAttribute("data-active", "false");
            }
        });
    }

    function screenSaverPointerdownHandler() {
        window.screenSaverClickLock = true;
        setTimeout(() => {
            window.screenSaverClickLock = false;
        }, 500);

        setActiveScreen("allHomeDesigns"); // Activate All Home Designs
        mainApp.setAttribute("data-active", "true");
        screensaverApp.setAttribute("data-active", "false");

        // Ensure navMenu is always active when exiting screensaver
        if (navMenu) navMenu.setAttribute("data-active", "true");
        if (searchNavMenu) searchNavMenu.setAttribute("data-active", "false");
    }

    /***
     * Screensaver off: show All Home Designs with the nav menu active (the state a screensaver tap produces)
     */
    function activateMainApp() {
        setActiveScreen("allHomeDesigns");
        if (mainApp) mainApp.setAttribute("data-active", "true");
        if (navMenu) navMenu.setAttribute("data-active", "true");
        if (searchNavMenu) searchNavMenu.setAttribute("data-active", "false");
    }

    /***
     * Optimised Toggle Display Screens
     */
    buttons.forEach(button => {
        button.addEventListener("pointerdown", () => {
            setActiveScreen(button.dataset.target);
        });
    });

    /***
     * Optimised Navigation Toggle
     */
    if (openFiltersBtn && closeFiltersBtn && navMenu && searchNavMenu) {
        openFiltersBtn.addEventListener("pointerdown", () => {
            navMenu.setAttribute("data-active", "false");
            searchNavMenu.setAttribute("data-active", "true");
        });

        closeFiltersBtn.addEventListener("pointerdown", () => {
            searchNavMenu.setAttribute("data-active", "false");
            navMenu.setAttribute("data-active", "true");
        });
    }

    /***
     * Optimised Home Selection
     */
    if (selectHome && allHomeDesignsScreen) {
        selectHome.addEventListener("pointerdown", () => {
            setActiveScreen("allHomeDesigns");
        });
    }

    /***
     * Optimised Toggle Between Grid and Slider
     */
    if (toggleLayout && gridBtns && sliderBtns && homeGrid && homeSlider) {
        toggleLayout.addEventListener("change", () => {
            requestAnimationFrame(() => {
                const isGridActive = toggleLayout.checked;
                gridBtns.setAttribute("data-active", isGridActive ? "true" : "false");
                sliderBtns.setAttribute("data-active", isGridActive ? "false" : "true");
                homeGrid.setAttribute("data-active", isGridActive ? "true" : "false");
                homeSlider.setAttribute("data-active", isGridActive ? "false" : "true");
            });
        });

        // Set initial state
        toggleLayout.dispatchEvent(new Event("change"));
    }

    /***
     * Optimised System Reset and Screensaver Handling
     */
    function resetInactivityTimer() {
        clearTimeout(inactivityTimer);
        inactivityTimer = setTimeout(() => {
            if (systemResetBtn) systemResetBtn.click();
        }, 600000); // 10 minutes
    }

    function resetAndPlayAllVideos() {
        document.querySelectorAll('video').forEach(video => {
            video.currentTime = 0;
            video.play().catch(error => {
                console.warn('Video could not be played automatically:', error);
            });
        });
    }

    if (systemResetBtn && mainApp && screensaverApp) {
        systemResetBtn.addEventListener("click", () => {
            mainApp.setAttribute("data-active", "false");
            screensaverApp.setAttribute("data-active", "true");
            resetInactivityTimer();
            resetAndPlayAllVideos();
        });

        // Ensure Clicking Screensaver Switches to All Home Designs & Reactivates Nav Menu
        screensaverApp.addEventListener("pointerdown", () => {
            screenSaverPointerdownHandler();
            resetInactivityTimer();
        });
    } else if (mainApp && !screensaverApp) {
        // Screensaver off: the presence of #screensaverApp is authoritative. The panel is only rendered
        // when the entry's enableScreensaver toggle is on (data-screensaver on .display-screen mirrors
        // that for debugging). The display centre uses its own panel partial
        // (_displaycentre-screensaver-panel.twig), which has no toggle.
        // Start on All Home Designs; reset (and the idle timer) return there instead
        activateMainApp();

        if (systemResetBtn) {
            systemResetBtn.addEventListener("click", () => {
                activateMainApp();
                resetInactivityTimer();
                resetAndPlayAllVideos();
            });
        }
    }

    // Optimised Inactivity Timer with Debouncing
    const debouncedResetTimer = (() => {
        let timeout;
        return () => {
            clearTimeout(timeout);
            timeout = setTimeout(resetInactivityTimer, 500);
        };
    })();

    ["pointermove", "pointerdown", "keydown"].forEach(event =>
        document.addEventListener(event, debouncedResetTimer)
    );

    resetInactivityTimer();
});
